/* Belvoir&Co — cart upsell "Add": adds the variant and re-renders the drawer the theme's way. Delegated, so it survives drawer re-renders. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bv-upsell__add[data-variant-id]');
    if (!btn || btn.disabled) return;
    btn.disabled = true; btn.classList.add('is-busy');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] };
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.section; }); body.sections_url = window.location.pathname; }
    var routes = window.routes || {};
    fetch(((routes.cart_add_url || '/cart/add') + '.js').replace('.js.js', '.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status || res.errors) throw new Error(res.description || 'add failed');
      var open = btn.hasAttribute('data-open-drawer');
      if (cart && cart.renderContents) cart.renderContents(res, open);
      if (typeof updateCartCounters === 'function') updateCartCounters();
      if (open) { /* card button: show "Added", then reset — it is not re-rendered like the drawer shelf */
        var label = btn.textContent;
        btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.textContent = btn.getAttribute('data-added-label') || 'Added to bag';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1800);
      }
    }).catch(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
  });
})();


/* Keep the shelves in step with the bag: after any cart change or drawer open, re-fetch just the
   cart-drawer section and swap the shelf slot, then animate it in. Works whichever code path added the item. */
(function () {
  var busy = false, last = '';
  /* A shelf rendered by any path starts hidden (CSS) until it gets is-in — always grant it */
  function show(root) {
    var shelf = (root || document).querySelector('cart-drawer .bv-upsell:not(.is-in)');
    if (shelf) requestAnimationFrame(function () { shelf.classList.add('is-in'); });
  }
  function refresh() {
    if (busy) return; busy = true;
    var url = (window.location.pathname || '/') + '?sections=cart-drawer';
    fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (json) {
      var html = json['cart-drawer']; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-bv-upsell-slot]');
      var slot = document.querySelector('cart-drawer [data-bv-upsell-slot]');
      if (!fresh || !slot) return;
      if (fresh.innerHTML !== slot.innerHTML) slot.innerHTML = fresh.innerHTML;
      show(slot);
    }).catch(function () {}).finally(function () { busy = false; });
  }
  /* Theme pub/sub (cart updates from any form) */
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 50); });
  }
  /* Drawer opening (class toggled by the theme) */
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      var vis = drawer.classList.contains('is-visible');
      if (vis && !last) { show(); setTimeout(refresh, 120); }
      last = vis;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    /* First paint of a freshly rendered shelf (page load) */
    show();
    /* Theme re-renders swap the drawer body; catch the new shelf too */
    new MutationObserver(function () { show(); }).observe(drawer, { childList: true, subtree: true });
  }
  /* Our own Add buttons re-render via renderContents; animate the new shelf */
  document.addEventListener('click', function (e) { if (e.target.closest('.bv-upsell__add')) setTimeout(refresh, 900); });
})();


/* Classy exit: when the theme re-renders the drawer body, fade the current shelf out first, then let the
   re-render happen. Wraps the theme's CartDrawer.renderContents; everything else is untouched. */
(function () {
  function wrap() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C || C.prototype.__bvWrapped) return;
    var orig = C.prototype.renderContents;
    C.prototype.renderContents = function (response, open) {
      var self = this, args = arguments;
      var shelf = this.querySelector('.bv-upsell.is-in');
      if (!shelf || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return orig.apply(self, args);
      shelf.classList.add('is-out');
      setTimeout(function () { orig.apply(self, args); }, 260);
    };
    C.prototype.__bvWrapped = true;
  }
  wrap();
  if (window.customElements) customElements.whenDefined('cart-drawer').then(wrap);
})();